import { AfterViewInit, Directive, ElementRef, Inject, Optional } from '@angular/core';

import { getHostOrigin, isExternalUrl } from '../helpers/url.helper';
import { SERVER_REQUEST, ServerRequest } from '../server/server.tokens';
import { WindowRefService } from '../window-ref/window-ref.service';

/**
 * Automatically adds `target="_blank"` to the anchor element,
 * in case its href value refers to an external domain.
 */

@Directive({
  selector: 'a[shrdUtcAutoTarget]'
})
export class AutoTargetDirective implements AfterViewInit {
  private static origin: string;

  constructor(
    private readonly elementRef: ElementRef<HTMLAnchorElement>,
    @Optional() @Inject(SERVER_REQUEST) request: ServerRequest,
    { nativeWindow }: WindowRefService
  ) {
    AutoTargetDirective.origin ||= getHostOrigin(nativeWindow, request);
  }

  ngAfterViewInit(): void {
    const { nativeElement } = this.elementRef;
    if (isExternalUrl(nativeElement.href, AutoTargetDirective.origin)) {
      nativeElement.target = '_blank';
    }
  }
}
